import { Plug } from '../../components/Plug/Plug';
import './ProjectPage.scss';

export const ProjectPage = () => {
  return (
    <section className="gallery">
      <Plug />
    </section>
  );
};